<template>
    <input-row :label="label">
        <div class="form-file-box" style="width:100%">
            <v-row align="center" class="row--small">
                <v-col sm="10">
                    <v-file-input v-model="temp" dense hide-details outlined />
                </v-col>
                <v-col cols="auto" sm="2">
                    <v-btn block elevation="0" dark color="grey-dark" class="w-100 h-100 input-btn" @click="addFile">첨부</v-btn>
                </v-col>
            </v-row>
            <v-chip-group v-model="value" multiple>
                <v-chip v-for="(file, i) in value" :key="i" :value="file">
                    <span>{{ file.name }}</span>
                    <v-icon small>mdi-close</v-icon>
                </v-chip>
            </v-chip-group>
        </div>
    </input-row>
</template>

<script>
import InputRow from "@/components/client/dumb/input-row.vue";
export default {
    components: { InputRow },
    props: ["value", "label"],
    data() {
        return { temp: null };
    },
    methods: {
        addFile() {
            if (this.temp) {
                this.$emit("input", [...this.value, this.temp]);
                this.temp = null;
            } else alert("파일을 추가하세요.");
        },
    },
};
</script>

<style></style>
